import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=86874902&scoped=true"
import script from "./upload.js?vue&type=script&lang=js&external"
export * from "./upload.js?vue&type=script&lang=js&external"
import style0 from "./upload.vue?vue&type=style&index=0&id=86874902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86874902",
  null
  
)

export default component.exports